import React from 'react';
import Typography from '@mui/material/Typography';

type ToastFeedbackMessageProps = {
  message: string;
};

function ToastFeedbackMessage({ message }: ToastFeedbackMessageProps) {
  return <Typography align="center">{message}</Typography>;
}

export default ToastFeedbackMessage;
